import CryptoJS from 'crypto-js';
import Pagination from '../../../shared/components/pagination'
import CustomExpandableTable from '../../../shared/components/customExpandableTable'
import Loader from '../../../shared/components/loader'
import CONSTANT from '../../../shared/constants/constant'
import Multiselect from 'vue-multiselect'
import HubServices from '../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service'
import Printd from 'printd'
import FTCMemoDepositSlip from '../FtcRadShipment/FTCMemoDepositSlip'
import Util from '../../../shared/util/util'
import moment from 'moment';
import XLSX from 'xlsx';

export default{
name:"FTCDigitalTransaction",
components:{
    Pagination,
    CryptoJS,
    CustomExpandableTable,
    Loader,
    Multiselect,
    HubServices,
    FTCMemoDepositSlip,
    Util
},
data: function(){
    return{
        isLoading: false,
        awb:'',
        tableColumn: ['Way Bill No.','Client Name','XB Transaction ID','Amount Deposited(INR)','RAZORPAY Transaction ID','Deposit Date','Actions'],
        tableItems: [],
        innerTableColumn: [],
        totalPage: 0,
        currentPage: 1,
        totalCount: 0,
        perPage: 0,
        pageLimit: CONSTANT.PER_PAGE_DATA,
        offset: 0,
        hubid:'',
        parentObj: {},
        showPrintCashMemo:false,
        printAwb:[],
        totalamount:'',
        clienName:[]
    }
},
computed:{},
async mounted(){
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.defaultHubID = userdetail.hubID[0];
    if(userdetail.rolename[0] == "Hub Executive"){
      this.hubid = userdetail.hubID[0]
    }else{
    }
    this.getTransactionList()
    this.getTotalAmount()

},
methods:{
    async getCustomTableEvent(event){
        console.log("event",event);
        if(event.actionType == 'cashMemo'){
            this.parentObj.AWB = event.id;
            this.parentObj.action = event.actionType;
            this.clickPrintCashMemo();
        }

    },
    onPageChange(page){
        this.currentPage = page;
        this.offset = (page - 1) * this.pageLimit
        this.getTransactionList()
    },
    reset(){
        this.awb = '',
        this.currentPage = 1
        this.offset = 0;
        this.onPageChange(1)
        this.getTransactionList()
    },
    search(){
      this.getTransactionList()
    },

    async getTransactionList(){
        try{
            this.isLoading = true
            let input = {
                offset: this.offset,
                limit: this.pageLimit
            }
            if(this.awb){
                input.awb = this.awb
            }
            if(this.hubid){
              input.hubid = this.hubid
            }
            let result = await HubServices.getFtcDigitalTransactions(input)
            if(result.data.code ==200){
                this.totalCount = result.data.data.count
                this.tableItems = result.data.data.rows.map((el)=>{
                    return {
                      'id':el.id,
                      'AWB':el.awb,
                      'Way Bill No.':el.awb,
                      'Client Name':el.clientname,
                      'XB Transaction ID':el.transactionid,
                      'Amount Deposited(INR)':el.ftctotalamt,
                      'RAZORPAY Transaction ID':el.ftcpaymenturl,
                      'Deposit Date':Util.displayDateTimeFormat(el.lastmodifieddate),
                      'iscompletebooking' : true,
                      "Cash Memo Generate": el.iscashmemogenerated == 1 ? "Yes" : "No",
                      'Actions':'click OnEvent'
                    }
                   })
            }else{
              this.totalCount = 0
              this.tableItems = [];
            }
            if (this.totalCount < this.pageLimit) {
              this.totalPage = 1
            } else {
              this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
            }
              this.isLoading = false
        }catch(err){
            this.isLoading = false
            console.log(err)
        }
    },
    async clickPrintCashMemo() {
        this.isLoading = true;
        await this.setMulipleAwbData(this.parentObj.AWB)
        this.showPrintCashMemo = true;
        this.isLoading = false;
    },
    async setMulipleAwbData(){
        this.printAwb=[]
          let data = await this.GetCashMemoData()
          if(data.data.code == 200){
          this.printAwb.push(data.data.data)
          }else{
            this.$alert(item.AWB + " - " + data.data.message,"", "error");
          }
      },
      async GetCashMemoData(){
        let payload = {
          awb:this.parentObj.AWB,
        }
        let data = await HubServices.GetCashMemoData(payload)
        return data
      },
      async printCashMemo(){
        try {
          if (this.printAwb.length < 1) {
            this.isLoading = false
            return
          }
        const d = new Printd();
        var buffer = '';
  
        var cssText = `
             body{
                 -webkit-print-color-adjust:exact;
                 font-family: Roboto,sans-serif;
                 font-size:20%;
             }
             hr {
                  margin-top: 1rem;
                  margin-bottom: 1rem;
                  border: 1;
                  border-top: 1px solid #000;
              }
             table {
                 border-collapse: collapse;
                 margin-left:3px !important;
             }
             table, td, th {
               border-style: solid;
               border-width: 1px;
               padding:5px;
             }
             .text-right{
               text-align:right;
             }
             .text-left{
               text-align:left;
             }
             .text-center{
               text-align:center;
             }
             .h3-center-text{
               text-align:center;
             }
             @media print {
             .text-primary th{
               background-color:rgb(226, 216, 216) !important;
               color:black !important;
               font-size:20px !important;
             }
            }
            @media print {
            .pagebreak {
            page-break-after: always;
            }
            }
            `
            this.$nextTick(() => {
              d.print(document.getElementById('printCashMemoData'), cssText);
            })
      } 
      catch (error) 
      {
        this.isLoading=false
      }
    },
    async downloadSheet(){
      try {
        this.isLoading = true;
        let inputPayload = {}
        if(this.awb){
          inputPayload.awb = this.awb
        }
        if(this.hubid){
          input.hubid = this.hubid
        }
        let result = await HubServices.getFtcDigitalTransactions(inputPayload)
        if(result.data.code==200){
          let tempdata = result.data.data.rows.map((el)=>{
            return {
              'AWB':el.awb,
              'Way Bill No.':el.awb,
              'Client Name':el.clientname,
              'XB Transaction ID':el.transactionid,
              'Amount Deposited(INR)':el.ftctotalamt,
              'RAZORPAY Transaction ID':el.ftcpaymenturl,
              'Deposit Date':Util.displayDateTimeFormat(el.lastmodifieddate),
            }
           })
           let dt = moment().tz('Asia/Kolkata').format('YYYYMMDDHHmmss');
          const data = XLSX.utils.json_to_sheet(tempdata);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, data, 'data')
          XLSX.writeFile(wb,'FTC_Digital_Payment.xlsx');
        }else{
          this.$alertify.error(result.data.message);
        }
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
  },
  async getTotalAmount(){
    try{
      this.isLoading = true
      let input = {}
      if(this.hubid){
        input.hubid = this.hubid
      }
      let amount = await HubServices.getTotalAmount(input)
      if(amount.data.code == 200){
        this.totalamount = amount.data.data[0].total
      }else{
        this.totalamount = 0
      }
      this.isLoading = false
    }catch(err){
      console.log(err);
    }
  }
}
}


// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/FTCPaymentMode/ftcdigitaltransactions.component.js